
import { getTwelveBankAccountsApi } from 'api/dealApi';
import { buildTwelveBankAccountOptions } from 'helpers/twelveBankAccounts';
import { useEffect, useMemo, useState } from 'react';

export function useTwelveBankAccounts({ includeAccountIds = [] } = {}) {
  const [bankAccounts, setBankAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const includeAccountIdsKey = (includeAccountIds || []).filter(Boolean).join(',');

  useEffect(() => {
    const fetchBankAccounts = async () => {
      try {
        setLoading(true);
        const accounts = await getTwelveBankAccountsApi();
        setBankAccounts(accounts);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchBankAccounts();
  }, []);

  const bankAccountOptions = useMemo(
    () =>
      buildTwelveBankAccountOptions(bankAccounts, {
        includeAccountIds: includeAccountIdsKey
          ? includeAccountIdsKey.split(',')
          : [],
      }),
    [bankAccounts, includeAccountIdsKey]
  );

  return {
    bankAccounts,
    bankAccountOptions,
    isTwelveBankAccountsLoading: loading,
  };
}
